import React from 'react';
import { useTheme } from './ThemeProvider';

export type FilterType =
  | 'all'
  | 'system'
  | 'action'
  | 'settings'
  | 'file'
  | 'view';

interface FilterBarProps {
  activeFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
  hasResults: boolean;
  isComponentActive: boolean;
  availableFilters?: Array<{ type: FilterType; label: string; count?: number }>;
}

const FilterBar: React.FC<FilterBarProps> = ({
  activeFilter,
  onFilterChange,
  hasResults,
  isComponentActive,
  availableFilters,
}) => {
  const { provideTailwind } = useTheme();

  const filters: { type: FilterType; label: string; count?: number }[] =
    availableFilters || [
      { type: 'all', label: 'All' },
      { type: 'system', label: 'System' },
      { type: 'action', label: 'Action' },
      // Add more filters as needed
      // { type: 'settings', label: 'Settings' },
      // { type: 'file', 'Files' },
      // { type: 'view', label: 'Views' },
    ];

  if (!hasResults || isComponentActive) {
    return null;
  }

  return (
    <div className="filter-bar mb-2 pt-2">
      <div className="flex items-center text-xs">
        {filters.map((filter, index) => (
          <React.Fragment key={filter.type}>
            <button
              onClick={() => onFilterChange(filter.type)}
              className={`px-1 transition-colors ${
                activeFilter === filter.type
                  ? `${provideTailwind('text-filter-active')} font-medium`
                  : `${provideTailwind(
                      'text-filter-inactive',
                    )} ${provideTailwind('hover:text-filter')}`
              }`}
            >
              {filter.label}
            </button>
            {index < filters.length - 1 && (
              <span
                className={`${provideTailwind('text-filter-separator')} mx-1`}
              >
                |
              </span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export { FilterBar };
export default FilterBar;
